import { MessageText } from '../../BaseQuickActionModal/styles/BaseModal.styles';
import styled from 'styled-components';

export const MainMessage = styled(MessageText)`
  margin-top: 20px;
`;
